module.exports = __webpack_public_path__ + "img/topic-classification.b7315b03.svg";